import { PaginatedEntity } from '@core/entities';
import { Expose, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';

export class UserContentGroupList extends PaginatedEntity {
  @Type(() => UserContentGroupEntity)
  groups: UserContentGroupEntity[];
}

export class UserContentGroupEntity {
  id: number;
  description: string;

  @Expose({ name: 'name' })
  title: string;

  // For Ui use only
  imageUrl: string | SafeUrl;
}
